import get from 'lodash.get';

const getSite = (id, rootState) =>
  get(rootState, 'sites.data.results', []).find((site) => site.id === id) || null;

export default getSite;
